import React from 'react';
import { Button, Text, View } from "../../../Components/Themed"
import type { AthleteProps, LeagueProps, OrderProps, ParlayPositionProps, ParlayProps, PublicPlayerProps, TeamProps } from '../../../types';
import { FlatList, Image, type ViewStyle } from 'react-native';
import { MarketComponentHelpers } from '../../api';
import { useColors } from '../../../constants/useColors';
import { Icons } from '../../../Components';
import { AthleteImage, TeamImage } from '../../../Components/Jerseys';
import OrderGradeBar from '../OrderGradeBar';
import moment from 'moment-mini';
import { ParlayHelpers } from './api';

type ParlayCardProps = {
    parlay:ParlayProps,
    float?:boolean,
    card_style?:ViewStyle,
    header_style?:ViewStyle,
    footer_style?:ViewStyle,
    players:PublicPlayerProps[],
    leagues:LeagueProps[],
    teams:TeamProps[],
    athletes:AthleteProps[],
    parlay_positions:ParlayPositionProps[],
    orders:OrderProps[]
}

const ParlayCard = ({ float, card_style, header_style, footer_style, teams, athletes, leagues, players, parlay, orders }:ParlayCardProps) => {
    const Colors = useColors();
    const parlay_owner = players.find(p => p.player_id == parlay.player_id);

    const available = ParlayHelpers.calcAvailable(parlay);


    const renderLegs = (data:{ item:OrderProps, index:number }) => {
        const athlete = athletes.find(a => a.athlete_id == data.item.side_id);
        const team = teams.find(t => t.team_id == data.item.side_id);
        let league = leagues.find(l => l.league_id == team?.league_id);
        if(data.item.side_type == 'athlete'){ league = leagues.find(l => l.league_id == athlete?.league_id) }
        return (
            <View type='row' style={{ padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                {data.item.side_type == 'team' && team ?
                <TeamImage
                    team={team}
                    league={league}
                    size={30}
                />
                :data.item.side_type == 'athlete' && athlete ?
                <AthleteImage
                    athlete={athlete}
                    league={league}
                    size={32}
                />
                :<></>}
                <View transparent style={{ flex:1 }}>
                    <Text theme='h2'>{data.item.title}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{(data.item.probability*100).toFixed()}% ({MarketComponentHelpers.getOddsLabel(data.item.odds)})</Text>
                </View>
                <OrderGradeBar grade={data.item.grade} view_type='book'/>
            </View>
        )
    }

    return (
        <View float={float} style={{ ...card_style }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, ...header_style }}>
                <Icons.ParlayIcon size={28} color={Colors.text.h1}/>
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h2'>{parlay.name}</Text>
                    <Text theme='light' style={{ marginTop:3 }}>Expires on {moment(parlay.expire_datetime).format('ddd hh:mm a')}</Text>
                </View>
                <View transparent style={{ alignItems:'flex-end' }}>
                    <Text theme='h2'>{parlay.open_amt.toFixed(2)} to win {parlay.potential_winnings.toFixed(2)}</Text>
                    <Text theme='light' style={{ marginTop:3 }}>{(parlay.probability*100).toFixed()}% ({MarketComponentHelpers.getOddsLabel(parlay.odds)})</Text>
                </View>
            </View>
            <View type='body'>
                <FlatList
                    data={orders}
                    renderItem={renderLegs}
                    keyExtractor={(item) => item.order_id.toString()}
                />
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, ...footer_style }}>
                {parlay.show_me && parlay_owner ?
                <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                    <View float style={{ borderRadius:100, padding:2 }}>
                        <Image
                            source={{ uri: parlay_owner.profile_pic && parlay_owner.profile_pic != '' ? parlay_owner.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}    
                            style={{ height:35, width:35, borderRadius:100 }}
                            resizeMode='cover'
                        />
                    </View>
                    <View transparent style={{ marginLeft:10 }}>
                        <Text theme='light'>Created By</Text>
                        <Text theme='h2' style={{ marginTop:2 }}>@{parlay_owner.username}</Text>
                    </View>
                </View>
                :<></>}
                <View transparent style={{ flex:1 }} />
                <View transparent style={{ alignItems:'flex-end', marginRight:10 }}>
                    <Text theme='h2' color={Colors.text.success}>{available.toFixed(2)}</Text>
                    <Text style={{ marginTop:3 }} theme='light'>Available</Text>
                </View>
                {parlay.offer_side == 'taker' ?
                <Button
                    type='success'
                    style={{ flexDirection:'row', alignItems:'center' }}
                >
                    <Icons.BankIcon color={Colors.text.h1} size={14} />
                    <Text theme='h2' style={{ marginLeft:5 }} color={Colors.text.white}>House It</Text>
                </Button>
                :
                 <Button
                    type='success'
                    style={{ flexDirection:'row', alignItems:'center' }}
                >
                    <Icons.USDIcon color={Colors.text.h1} size={14} />
                    <Text theme='h2' style={{ marginLeft:5 }} color={Colors.text.white}>Take It</Text>
                </Button>
                }
                
            </View>
        </View>
    )
}

export default ParlayCard